if (!customElements.get('product-addon')) {
  customElements.define(
    'product-addon',
    class ProductAddon extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.product-addon__submit');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorMessage = this.querySelector('.product-addon__error');
        this.checkbox = this.querySelector('.product-addon__checkbox');
        this.totalPriceEl = this.querySelector('[data-total-price]');

        this.button.addEventListener('click', this.onSubmit.bind(this));
        if (this.checkbox) {
          this.checkbox.addEventListener('change', this.updateTotal.bind(this));
        }
      }

      updateTotal() {
        if (!this.totalPriceEl) return;
        const checked = this.checkbox && this.checkbox.checked;
        this.totalPriceEl.textContent = checked
          ? this.dataset.combinedFormatted
          : this.dataset.mainOnlyFormatted;
      }

      onSubmit(event) {
        event.preventDefault();
        this.errorMessage.setAttribute('hidden', true);
        this.button.setAttribute('disabled', true);
        this.button.classList.remove('product-addon__submit--success');
        this.spinner.classList.remove('hidden');

        const items = [{ id: this.dataset.mainVariantId, quantity: 1 }];
        if (this.checkbox && this.checkbox.checked) {
          items.push({ id: this.checkbox.dataset.variantId, quantity: 1 });
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.errorMessage.textContent =
                response.description || 'No se pudo agregar el producto al carrito.';
              this.errorMessage.removeAttribute('hidden');
              return;
            }
            this.spinner.classList.add('hidden');
            this.button.classList.add('product-addon__submit--success');
            const label = this.button.querySelector('.product-addon__submit-label');
            if (label) label.textContent = '¡Agregado! Redirigiendo…';
            window.setTimeout(() => {
              window.location.href = this.dataset.cartUrl;
            }, 450);
          })
          .catch(() => {
            this.errorMessage.textContent = 'Ocurrió un error, intentá de nuevo.';
            this.errorMessage.removeAttribute('hidden');
          })
          .finally(() => {
            if (!this.button.classList.contains('product-addon__submit--success')) {
              this.button.removeAttribute('disabled');
              this.spinner.classList.add('hidden');
            }
          });
      }
    }
  );
}
